import React from 'react';

import type { Placement } from '@atlaskit/spotlight';

import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { fg } from '@confluence/feature-gating';

import { AIFCDeeplinkReturnSpotlight } from './AIFCDeeplinkReturnSpotlight.tsx';

export type AIFCDeeplinkReturnSpotlightProps = {
	children: React.ReactNode;
	offset?: [number | null | undefined, number | null | undefined];
	placement?: Placement;
};

export const AIFCDeeplinkReturnSpotlightWrapper = ({
	children,
	...props
}: AIFCDeeplinkReturnSpotlightProps): React.ReactNode => {
	if (!fg('cc_fd_aifc_deeplink_return_nudge_enabled')) {
		return children;
	}

	return (
		<AIFCDeeplinkReturnSpotlightInternal {...props}>{children}</AIFCDeeplinkReturnSpotlightInternal>
	);
};

const AIFCDeeplinkReturnSpotlightInternal = withTransparentErrorBoundary({
	attribution: Attribution.FLYWHEEL_FEATURE_DISCOVERY,
})(AIFCDeeplinkReturnSpotlight);
